/**
 * Testimonial data for the /pricing strip under the tiers.
 *
 * Real quotes from Stag Vault members — verified as of 15 July 2026.
 * Both are product-experience testimonials, NOT earnings claims, so they
 * do not require documented revenue evidence under UK CMA / US FTC rules.
 *
 * When ADDING a new testimonial:
 *   1. Get the member's written consent to publish their first name + city.
 *   2. If the quote mentions £ amounts, verify the figure (screenshot / invoice)
 *      and note evidence source in your compliance file.
 *   3. Only set `verified: true` after you have documented consent + evidence.
 */
export const PRICING_TESTIMONIALS = [
  {
    id: "t-lee",
    quote:
      "This app has changed the way we market our offerings. From a long-winded offer-and-price scroller to a single-page infographic covering all key information.",
    attribution: "Lee",
    location: "",
    tier: "Lifetime",
    revenue: null, // no earnings claim — product-experience quote
    verified: true,
  },
  {
    id: "t-chloe-mark",
    quote:
      "My friend Mark signed up to Stag Vault — he loves it. We're gonna do the Faceless YouTube track together first.",
    attribution: "Chloe & Mark",
    location: "",
    tier: "Lifetime",
    revenue: null,
    verified: true,
  },
];
